import React from "react";
import ImageCard from "./ImageCard";
import ShareButton from "../../components/Buttons/ShareButton";
import moment from "moment";
import { useRouter } from "next/router";

const ResourceCard = ({ resource }) => {
    const Router = useRouter();
    const getCreatorName = creatorArr => {
        let creatorName = "";
        creatorArr.map((creatorObj, i) => {
            if (i === 0) creatorName = creatorObj.name;
            else if (i === creatorArr.length - 1) creatorName + "& " + creatorObj.name;
            else creatorName = creatorName + ", " + creatorObj.name;
        });
        return creatorName;
    };
    const getResourceType = resource => {
        switch (resource) {
            case 1:
                return "Video";
                break;
            case 2:
                return "Slide";
                break;
            case 3:
                return "Blog";
                break;
            case 4:
                return "GitHub";
                break;
            case 5:
                return "EBook";
                break;
            default:
                return "";
                break;
        }
    };
    const resourceHandle = () => {
        Router.push(`/resources/${resource?.id}`);
    };
    return (
        <div className="col-lg-4 col-md-6 col-sm-6 mb-4 d-flex">
            <div
                className="event-card d-flex flex-column gap-4"
                style={{ width: "100%" }}
            >
                <ImageCard
                    resource={resource}
                    backgroundUrl={
                        resource.poster_url
                            ? resource.poster_url
                            : "https://image-dock-uploads-be.s3.ap-south-1.amazonaws.com/image.2021-04-19T04%3A54%3A26.365Z"
                    }
                    getResourceType={getResourceType}
                />
                <div className="d-flex flex-column">
                    <div className="d-flex flex-column justify-content-between">
                        <div className="d-flex justify-content-between">
                            <h5 style={{ maxWidth: "305px" }} className="card-title" onClick={resourceHandle}>{resource.title}</h5>
                            <div className="share-container">
                                <ShareButton
                                    url={resource.resource_url}
                                    content={`Check out this ${getResourceType(
                                        resource.resource_type
                                    ).toLowerCase()} by ${getCreatorName(resource.creator)}`}
                                    emailSubject={`Konfhub Resource - ${getResourceType(
                                        resource.resource_type
                                    )} by ${getCreatorName(resource.creator)}`}
                                />
                            </div>
                        </div>
                        <div>
                            <ul className="list-unstyled">
                                <li>
                                    <span className="list-item-txt">{getCreatorName(resource.creator)}</span>
                                </li>
                                <li className="d-flex">
                                    <img
                                        style={{
                                            height: "16px",
                                            width: "16px",
                                            objectFit: "contain",
                                            borderRadius: "8px",
                                        }}
                                        src="https://d2nnrpx7gk2my2.cloudfront.net/files/67050400665ab60009478ec7/calendar.svg"
                                        alt=""
                                    />{" "}
                                    <span className="list-item-txt">{moment(resource?.published_on).format("Do MMMM YYYY")}</span>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                    .event-card {
                        border: 1px solid #d9d9d9;
                        border-radius: 8px;
                        transition: transform 0.2s ease;
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        padding: 16px;
                    }

                    .event-card:hover {
                        transform: translateY(-5px);
                    }

                    .event-card .card-img-top {
                        object-fit: contain;
                        border-radius: 8px;
                        border: 1px solid #d9d9d9;
                    }

                    .event-card .card-body {
                        padding: 16px;
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                    }

                    .event-card .card-title {
                        font-size: 20px;
                        font-weight: 600;
                        color: #002e6e;
                        line-height: 24px;
                        height: auto;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        cursor: pointer;
                    }

                    .event-card .list-unstyled {
                        padding: 0;
                        margin: 10px 0;
                        font-size: 14px;
                        color: #666;
                    }

                    .event-card .list-unstyled li {
                        margin-bottom: 7px;
                    }

                    .event-card .card-price {
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 24px;
                        color: #002e6e;
                        margin-top:10px;
                    }

                    .list-item-txt {
                        font-size: 14px;
                        font-weight: 500;
                        color: #525252;
                        line-height: 21px;
                        margin-left: 6px;
                    }
                    .share-container {
						display: flex;
                        height:fit-content;
					}

                    @media (max-width: 768px) {
                        .event-card img {
                            height: 120px;
                        }
                    }
                    @media (max-width: 1200px) {
                        .card-title {
                          max-width:218px !important;
                        }
                    }
                `}</style>
        </div>
    );
};

export default ResourceCard;